import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * ### 文書送付カテゴリー API 操作クラス
 */
export default class SendDocumentCategories {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * ### GET SendDocumentCategories
   */
  public async gets(userStore: LoginUser, queryParams?: { startIndex?: number; endIndex?: number }): Promise<Array<SendDocumentCategoryGetModel>> {
    const formatParams: any = {
      facilityId: userStore.loginUser.facilityId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.SendDocumentCategories, formatParams);

    const params: any = queryParams ? queryParams : {};
    const response = await this.commonService.executeGet<Array<SendDocumentCategoryGetModel>>(
      userStore,
      requestUrl,
      this.constructor.name,
      params,
      HitomeqErrorType.REQUEST_RETRY,
      0
    );

    return response.data;
  }

  /**
   * PATCH SendDocumentCategory
   */
  public async patch(userStore: LoginUser, id: number, requestBody: SendDocumentCategoryPatchModel): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.loginUser.facilityId,
      id: id
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.SendDocumentCategory, formatParams);

    const response = await this.commonService.executePatch<any>(userStore, requestUrl, requestBody, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}

export interface SendDocumentCategoryGetModel {
  /** 施設ID */
  facilityId: number;
  /** 部屋を示す ID */
  id: number;
  /** 文書送付カテゴリー名 */
  name: string;
  /** 説明文 */
  description: string;
  /** 有効かどうか */
  enabled: boolean;

  /** 論理削除フラグ */
  deleteFlag: boolean;
  /** 最終更新日 */
  updated: number;
  /** 作成した日付(YYYYMMDDhhmmssSSS) */
  created: number;
}

export interface SendDocumentCategoryPatchModel {
  /** 文書送付カテゴリー名 */
  name: string;
  /** 説明文 */
  description: string;
  /** 有効かどうか */
  enabled: boolean;
  /** 更新日時 */
  updated: number;
}
